<ngb-carousel *ngIf="recensioni.length>0">
    <ng-template ngbSlide *ngFor="let c of recensioni">
        <h2 style="color: whitesmoke;margin-left: 3%;margin-top: 2%;">RECENSIONI DEI CLIENTI</h2>
        <div class="picsum-img-wrapper">
            <div class="row">
            <div class="col-2"></div>
            <div class="card border-info col-8" id="card-cicle">
                <div id="card-titolo" class="card-header">{{c.payload.doc.data().cognome}} {{c.payload.doc.data().nome}}</div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-3 text-center">
                            <img src="/assets/p2.jpg" style="margin-bottom: 2%; margin-top: 2%; width: 150px; length:150px">
                        </div>
                        <div class="col-md-7">
                            <h2>{{c.payload.doc.data().cognome}} {{c.payload.doc.data().nome}}</h2>
                            <hr>
                            <h3>{{c.payload.doc.data().description}}</h3>
                        </div>

                        <div class="col-md-2">
                            <div class="c4l-rating" *ngIf="c.payload.doc.data().punteggio>=1">
                                <input name="c4l-rating" type="radio" id="c4l-rate1" value="1" />
                                <label for="c4l-rate1"></label>

                                <input name="c4l-rating" *ngIf="c.payload.doc.data().punteggio>=2" type="radio" id="c4l-rate2" value="2" />
                                <label for="c4l-rate2"></label>

                                <input name="c4l-rating" *ngIf="c.payload.doc.data().punteggio>=3" type="radio" id="c4l-rate3" value="3" />
                                <label for="c4l-rate3"></label>

                                <input name="c4l-rating" *ngIf="c.payload.doc.data().punteggio>=4" type="radio" id="c4l-rate4" value="4" />
                                <label for="c4l-rate4"></label>

                                <input name="c4l-rating" *ngIf="c.payload.doc.data().punteggio>=5" type="radio" id="c4l-rate5" value="5" checked />
                                <label for="c4l-rate5"></label>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
            <div class="col-2"></div>
        </div>
        </div>
    </ng-template>
</ngb-carousel>
